import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import CountryPriceList from '../data/CountryPriceList.json';
import { Chip } from '@mui/material';

export default function CountryPriceSelect({
  handleSelect,
  selected,
  multiple,
  limit,
}) {
  const filterOptions = createFilterOptions({
    stringify: ({ label, code }) => `${label} ${code}`,
  });

  return (
    <Autocomplete
      multiple={multiple ? true : false}
      disableCloseOnSelect={multiple ? true : false}
      limitTags={3}
      size='small'
      options={CountryPriceList}
      filterOptions={filterOptions}
      autoHighlight
      getOptionLabel={(option) => option.label}
      onChange={handleSelect}
      getOptionDisabled={(options) =>
        selected && selected.length > limit - 1 ? true : false
      }
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant='outlined'
            label={option.code}
            size='small'
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(props, option) => (
        <Box
          component='li'
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading='lazy'
            width='20'
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=''
          />
          {option.label} ({option.code})
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Choose a country'
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
    />
  );
}
